"use strict";
/**
 * 资金流图
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZJLline = void 0;
var dsvg_1 = require("../dsvg");
var watermark_1 = require("../watermark");
var formatdata_1 = require("./formatdata");
var default_options = {
    fontsize: 12,
    interaction: true,
    topinfoheight: 25,
    bottominfoheight: 20,
    padding: {
        t: 10,
        b: 10,
        l: 10,
        r: 10
    }
};
/**
 * 资金流图
 */
var ZJLline = /** @class */ (function () {
    function ZJLline(options) {
        this.options = Object.assign({}, default_options, options);
    }
    ZJLline.prototype.draw = function () {
        return __awaiter(this, void 0, void 0, function () {
            var y_datas, x_datas;
            return __generator(this, function (_a) {
                y_datas = this.options.yaxis;
                x_datas = this.options.xaxis;
                // 接口数据
                // let apidata = await ZJLXLineData({
                //   ut: "bd1d9ddb04089700cf9c27f6f7426281",
                //   secid: "90.BK0894"
                // })
                // y_datas = Object.assign(y_datas, { data: apidata.ydata })
                // x_datas = Object.assign(x_datas, { data: apidata.xaxis })
                this.commondata = (0, formatdata_1.formatdata)(this.options, x_datas.trendsTotal, y_datas.data);
                //初始化svg
                this.container = document.createElement("div");
                this.container.className = "_emui_quote_chart";
                this.container.style.width = this.options.width + "px";
                this.container.style.height = this.options.height + "px";
                if (this.options.container.childNodes[0]) {
                    this.options.container.replaceChild(this.container, this.options.container.childNodes[0]);
                }
                else {
                    this.options.container.appendChild(this.container);
                }
                this.svg = new dsvg_1.DSVG(this.container, this.options.width, this.options.height);
                this.container.style.fontSize = this.options.fontsize + "px";
                drawImg(this.svg, {
                    y_datas: y_datas,
                    x_datas: x_datas
                }, this.commondata, this.options, this.container);
                return [2 /*return*/];
            });
        });
    };
    return ZJLline;
}());
exports.ZJLline = ZJLline;
function drawImg(svg, data, commondata, options, container) {
    // 画矩形
    drawLineRect(svg, options);
    // 画Y虚线
    drawGridYLine(svg, options, commondata);
    // 画纵坐标
    if (data.y_datas.data.length > 0) {
        drawPointY(svg, options, commondata);
    }
    // 画横坐标
    drawPointX(svg, data.x_datas.data, options, commondata);
    // 画折线
    drawBrokenLine(svg, options, data.y_datas.data, commondata);
    // 画顶部信息框
    drawTopInfos(svg, options, commondata, data.y_datas);
    // 绑定交互事件
    if (options.interaction) {
        bindEvent(container, data, options, commondata);
    }
    //水印
    (0, watermark_1.drawWaterMark)(svg.ele, 100, 20, (options.width - 100) - options.padding.r - 5, options.padding.t + 18);
    // 画中间txt文本信息
    drawMidTxt(svg, options);
}
/**
 * 画图区边框
 */
function drawLineRect(svg, options) {
    var outborder = svg.Rect(options.padding.l, options.padding.t, options.width - options.padding.l - options.padding.r, options.height - options.padding.b - options.padding.t);
    outborder.attr({ class: 'inner_border' });
}
/**
 * y轴横向虚线
 * @param svg
 * @param options
 * @param commondata
 */
function drawGridYLine(svg, options, commondata) {
    var padding = options.padding, bottominfoheight = options.bottominfoheight;
    var yPointUnit = commondata.yPointUnit;
    for (var i = 0; i < options.yaxis.pointnum; i++) {
        svg.HLine(padding.l, (options.height - padding.b) - yPointUnit * (i) - bottominfoheight, options.width - padding.l - padding.r).attr({ class: 'grid_dash_line' });
    }
}
/**
 * 纵坐标
 */
function drawPointY(svg, options, commondata) {
    var height = options.height, fontsize = options.fontsize, padding = options.padding, bottominfoheight = options.bottominfoheight;
    var yAxisPoints = commondata.yAxisPoints;
    for (var i = 0; i < yAxisPoints.length; i++) {
        // let shift = i == 0 ? 5 : 1;  // y坐标偏移量
        var y = (height - commondata.yPointUnit * i) - padding.b - bottominfoheight;
        if (i > 2) {
            y = (height - commondata.yPointUnit * i) - padding.b - bottominfoheight + fontsize - 2;
        }
        if (i == 2) {
            y = (height - commondata.yPointUnit * i) - padding.b - bottominfoheight + fontsize / 2 - 2;
        }
        var txt = svg.Text(padding.l + 2, y);
        txt.attr({ class: 'point_txt' });
        txt.ele.textContent = String((yAxisPoints[i]));
    }
}
/**
 * 横坐标
 */
function drawPointX(svg, data, options, commondata) {
    var x_scale = commondata.x_scale;
    var padding = options.padding, height = options.height, fontsize = options.fontsize;
    for (var i = 0; i < data.length; i++) {
        if (data[i].show) {
            var x = i * x_scale + options.padding.l;
            if (i != 0) {
                x = i * x_scale + options.padding.l - 35;
            }
            var txt = svg.Text(x, height - padding.b - fontsize / 2);
            txt.attr({ class: 'point_txt' });
            txt.ele.textContent = data[i].time;
        }
        // 纵向虚线
        if (data[i].showline && i != data.length - 1 && i != 0) {
            svg.VLine(i * x_scale + options.padding.l, padding.t, height - padding.b - padding.t).attr({ class: 'grid_dash_line' });
        }
    }
}
/**
 *  画折线
 */
function drawBrokenLine(svg, options, data, commondata) {
    var x_scale = commondata.x_scale;
    var padding = options.padding;
    var last = data[data.length - 1];
    var color = last > 0 ? "line_red" : last < 0 ? "line_green" : "";
    svg.Path(data.map(function (v, index) {
        var y = (0, formatdata_1.getIndexHeight)(v, options, commondata);
        return {
            x: index * x_scale + padding.l + 1,
            y: y
        };
    })).attr({ class: color });
}
/**
 * 顶部信息
 */
function drawTopInfos(svg, options, commondata, ydatas) {
    var _a, _b, _c, _d;
    var topinfoheight = options.topinfoheight, padding = options.padding, fontsize = options.fontsize, title = options.title;
    var top = padding.t + topinfoheight - fontsize / 1.5;
    // title
    var name = svg.Text(padding.l + 2, top);
    name.ele.textContent = title;
    name.attr({ 'class': 'zjl_txt' });
    var rect_name = name.ele.getBoundingClientRect();
    if (!ydatas.data.length)
        return false;
    // 最新值
    var last = (_a = ydatas === null || ydatas === void 0 ? void 0 : ydatas.data) === null || _a === void 0 ? void 0 : _a[((_b = ydatas === null || ydatas === void 0 ? void 0 : ydatas.data) === null || _b === void 0 ? void 0 : _b.length) - 1];
    var num = svg.Text(padding.l + 2 + rect_name.width + 5, top);
    var color = last > 0 ? "#ff0000" : last < 0 ? "#00811f" : "";
    num.ele.textContent = ((_c = ydatas === null || ydatas === void 0 ? void 0 : ydatas.data) === null || _c === void 0 ? void 0 : _c[((_d = ydatas === null || ydatas === void 0 ? void 0 : ydatas.data) === null || _d === void 0 ? void 0 : _d.length) - 1]) || "--";
    num.attr({ 'class': "zjl_num", fill: color });
    var rect_num = num.ele.getBoundingClientRect();
    // 单位
    var subfix = svg.Text(padding.l + rect_name.width + rect_num.width + 10, top);
    subfix.ele.textContent = ydatas.subfix;
    subfix.attr({ 'class': 'zjl_txt', fill: color });
}
/**
 * 图中查看大图跳转提示
 */
function drawMidTxt(svg, options) {
    var height = options.height, width = options.width;
    var name = svg.Text(width / 2 - 50, height / 2);
    name.ele.textContent = "点击查看大图";
    name.attr({ 'class': 'zjl_mid_tip' });
}
/**
 * 绑定交互事件
 */
function bindEvent(container, data, options, commondata) {
    var padding = options.padding, height = options.height, width = options.width;
    var x_scale = commondata.x_scale;
    var linerect = document.createElement('div');
    linerect.className = '_ui_chart_ctr';
    linerect.style.cssText = "\n    background:rgba(0,0,0,0);\n    width:".concat((width - padding.l - padding.r), "px;\n    left:").concat(padding.l, "px;\n    top:").concat(padding.t, "px;\n    height:").concat((height - padding.t - padding.b), "px\n    ");
    container.appendChild(linerect);
    // x轴左右移动虚线
    var x_move_line = document.createElement('div');
    x_move_line.className = 'x_move_line';
    x_move_line.style.cssText = "top:1px;height:".concat((height - padding.t - padding.b), "px");
    linerect.appendChild(x_move_line);
    // y轴上下移动虚线
    var y_move_line = document.createElement('div');
    y_move_line.className = 'y_move_line';
    y_move_line.style.cssText = "left:1px;width:".concat((width - padding.l - padding.r), "px");
    linerect.appendChild(y_move_line);
    // xy交汇点
    var xy_dot_div = document.createElement('div');
    xy_dot_div.className = "xy_dot_div";
    linerect.appendChild(xy_dot_div);
    // 浮窗信息框
    var tip_info_div = document.createElement('div');
    tip_info_div.className = "_ui_tip_zjlinfo";
    linerect.appendChild(tip_info_div);
    /*******/
    var trends = data.y_datas.data;
    linerect.addEventListener('mousemove', function (e) {
        var cur_index = Math.round(e.offsetX / x_scale);
        x_move_line.style.display = 'none';
        y_move_line.style.display = 'none';
        if (cur_index < 0 || cur_index >= trends.length) {
            if (x_move_line.style.display == 'none') {
                return false;
            }
            x_move_line.style.display = 'none';
            y_move_line.style.display = 'none';
            return false;
        }
        var y = (0, formatdata_1.getIndexHeight)(trends[cur_index], options, commondata) - padding.t;
        var x = e.offsetX + 1;
        x_move_line.style.display = 'block';
        x_move_line.style.left = x + 'px';
        // let y = (high_price - data.trends[showindex].close) * y_scale
        y_move_line.style.display = 'block';
        y_move_line.style.top = y + 'px';
        var dot_w = xy_dot_div.getBoundingClientRect().width || 15;
        xy_dot_div.style.cssText = "\n      display:block;left:".concat(e.offsetX - dot_w / 2, "px;top:").concat(y - dot_w / 2, "px\n    ");
        var cur_time = data.x_datas.data[cur_index].time;
        var cur_val = trends[cur_index];
        var rect_tip = tip_info_div.getBoundingClientRect();
        var color = cur_val > 0 ? "red" : cur_val < 0 ? "green" : "";
        tip_info_div.innerHTML = "<p class=\"_tip_txt\">".concat(cur_time, "</p><p class=\"_tip_txt\">").concat(data.y_datas.title, "\uFF1A<span class=\"").concat(color, "\">").concat(cur_val, " </span>").concat(data.y_datas.subfix, "</p>");
        var tip_right = width - padding.l - e.offsetX;
        var tip_left = e.offsetX + 10;
        if (e.offsetX < (width - padding.l - padding.r) / 2) {
            tip_info_div.style.cssText = "display:block;top:".concat(y - rect_tip.height / 2, "px;left:").concat(tip_left, "px");
        }
        else {
            tip_info_div.style.cssText = "display:block;top:".concat(y - rect_tip.height / 2, "px;right:").concat(tip_right, "px");
        }
    });
    linerect.addEventListener('mouseleave', function () {
        x_move_line.style.display = 'none';
        y_move_line.style.display = 'none';
        tip_info_div.style.display = 'none';
        xy_dot_div.style.display = 'none';
    });
    x_move_line.addEventListener('mousemove', function (e) {
        e.stopPropagation();
    });
    y_move_line.addEventListener('mousemove', function (e) {
        e.stopPropagation();
    });
    xy_dot_div.addEventListener('mousemove', function (e) {
        e.stopPropagation();
    });
}
